import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { isFunction as _isFunction } from 'lodash';

import { useCurrentUser } from '../context';
import { AppFeature, Role } from '../enum';
import { hasAccess, hasFeatureEnabled, isDashboardsPath } from '../utils';
import { ErrorFallback } from './error-fallback.component';

type ProtectedRouteProps = {
  requiredRoles?: Role[];
  requiredFeature?: AppFeature;
} & Omit<RouteProps, 'render' | 'component'>;

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  requiredRoles = [],
  requiredFeature,
  path,
  children,
  ...rest
}) => {
  const { role, hasTableauAccess } = useCurrentUser();

  const isAllowed =
    hasAccess(role, requiredRoles) &&
    hasFeatureEnabled(requiredFeature) &&
    (isDashboardsPath(path || '') ? hasTableauAccess : true);

  return isAllowed ? (
    <Route {...rest}>
      {(props) => (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          {_isFunction(children) ? children(props) : children}
        </ErrorBoundary>
      )}
    </Route>
  ) : (
    <Redirect to="/" />
  );
};
